import React, { useState } from "react";
import Termsandconditions from "../../components/T&C/Termsandconditions";
import SubscriptionTermsandconditions from "../../components/T&C/SubscriptionTermsandconditions";
import Layout from "../../components/Layout/Layout";

const tabs = [
  { id: "daily", label: "Daily Rental" },
  { id: "subscription", label: "Subscription" },
];

const Termsandcondition = () => {
  const [activeTab, setActiveTab] = useState("daily");

  return (
    <div>
      <Layout>
        <div className="pt-20 md:pt-24">
          {/* Tab switcher */}
          <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6">
            <div className="flex gap-1 bg-gray-100 p-1 rounded-xl w-fit mx-auto">
              {tabs.map(({ id, label }) => (
                <button
                  key={id}
                  onClick={() => setActiveTab(id)}
                  className={`px-5 py-2 rounded-lg text-sm font-semibold transition-all ${
                    activeTab === id
                      ? "bg-white text-red-600 shadow-sm"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          {/* Content — strip the inner pt-20 since we handle top padding above */}
          <div className="[&>div]:!pt-4">
            {activeTab === "daily" ? (
              <Termsandconditions />
            ) : (
              <SubscriptionTermsandconditions />
            )}
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Termsandcondition;
